import { render } from "./LcbftAlert.vue?vue&type=template&id=b13b6f7e"
import script from "./LcbftAlert.vue?vue&type=script&lang=js"
export * from "./LcbftAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__